import axios from 'axios';

const list = params => axios.get('/transportadoras/all', { params });
const getScore = id => axios.get(`/transportadoras/score/${id}`);

export default {
  list,
  getScore,
};
